/*!

=========================================================
* Material Dashboard React - v1.8.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2019 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/material-dashboard-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
// @material-ui/icons
import Dashboard from "@material-ui/icons/Dashboard";
import Person from "@material-ui/icons/Person";
import LibraryBooks from "@material-ui/icons/LibraryBooks";
//import BubbleChart from "@material-ui/icons/BubbleChart";
// import LocationOn from "@material-ui/icons/LocationOn";
//import Notifications from "@material-ui/icons/Notifications";
// import Unarchive from "@material-ui/icons/Unarchive";
//import Language from "@material-ui/icons/Language";
// core components/views for Admin layout
import DashboardPage from "views/Dashboard/Dashboard.js";
import DashboardPage2 from "views/Dashboard/Dashboard2.js";
import LoginPage from "views/UserProfile/LoginPage.js";
import LogoutPage from "views/UserProfile/LogoutPage.js";
import UserProfile from "views/UserProfile/UserProfile";
//import DashboardVaccine from "views/DashboardVaccine/DBVaccine.js";
import EditKPI from "views/Admin/EditKPI.js";
import TableList from "views/TableList/TableList.js";
import KPIDashboard from "views/KPIDashboard/KPIDashboard.js";
import Assessment from "@material-ui/icons/Assessment";
import Typography from "views/Typography/Typography.js";
import OtherData from "views/Typography/OtherData.js";
import ReportAccess from "views/Report/ReportAccess";
import Admin from "views/Admin/Admin.js";
//import Dataset from "views/Dataset/Dataset.js";
//import Vaccine from "views/Vaccine/Vaccine2.js";
import PersonAdd from "@material-ui/icons/PersonAdd";
import AccountCircle from '@material-ui/icons/AccountCircle';
import DesktopAccess from '@material-ui/icons/DesktopAccessDisabled';
import AddBox from "@material-ui/icons/AddBox";
import ReorderIcon from "@material-ui/icons/Reorder";
import SettingsIcon from "@material-ui/icons/Settings";
//import FolderOpenIcon from "@material-ui/icons/FolderOpen";
import Report from "views/Report/Report.js";
//import KeyboardIcon from '@material-ui/icons/Keyboard';
import EditDashboard from "views/Admin/EditDashboard.js";
//import DeveloperBoardIcon from '@material-ui/icons/DeveloperBoard';
import DesktopWindows from "@material-ui/icons/DesktopWindows";
//import Icons from "views/Icons/Icons.js";
//import Maps from "views/Maps/Maps.js";
//import NotificationsPage from "views/Notifications/Notifications.js";
// import UpgradeToPro from "views/UpgradeToPro/UpgradeToPro.js";
// core components/views for RTL layout
//import RTLPage from "views/RTLPage/RTLPage.js";
import Consultants from "views/Consultants/Consultants.js";
import SelectTest from "views/Admin/SelectTest";

import { userProfile } from "_services";

const dashboardRoutes = [
  {
    path: "/dashboard",
    name: "Dashboard",
    icon: Dashboard,
    component: DashboardPage,
    layout: "/datacenter"
    },
    //{
    //path: "/team",
    //name: "ทีมนำ",
    //icon: Dashboard,
    //component: DashboardPage2,
    //layout: "/datacenter"
    //}
    //,
    {
        path: "/login-page",
        name: "เข้าสู่ระบบ",
        icon: PersonAdd,
        component: LoginPage,
        layout: "/auth",
    },
    {
      path: "/profile",
      name: "จัดการข้อมูลส่วนตัว",
      icon: AccountCircle,
      component: UserProfile,
      layout: "/home",
  },
  {
    path: "/edit",
    name: "เพิ่ม/แก้ไข/อนุมัติ/ตัวชี้วัด",
    icon: AddBox,
    component: EditKPI,
    layout: "/datacenter"
  },
  {
    path: "/table",
    name: "รายการตัวชี้วัด",
    icon: ReorderIcon,
    component: TableList,
    layout: "/datacenter"
  },
  {
    path: "/kpi-dashboard",
    name: "Dashboard ตัวชี้วัด",
    icon: Assessment,
    component: KPIDashboard,
    layout: "/datacenter"
  },
  {
    path: "/management",
    name: "จัดการตัวชี้วัด",
    icon: LibraryBooks,
    component: Typography,
    layout: "/datacenter"
  },
  {
    path: "/admin",
    name: "จัดการกลุ่มงาน",
    icon: SettingsIcon,
    component: Admin,
    layout: "/datacenter"
  },
  {
    path: "/dbmanagement",
    name: "จัดการหน้า Dashboard",
    icon: SettingsIcon,
    component: EditDashboard,
    layout: "/datacenter"
  }
  ,
  {
    path: "/datamanagement",
    name: "แก้ไขข้อมูลอื่นๆ",
    icon: SettingsIcon,
    component: OtherData,
    layout: "/datacenter"
  },
  {
    path: "/report",
    name: "รายงาน",
    icon: DesktopWindows,
    component: Report,
    layout: "/datacenter"
  },
  {
    path: "/access",
    name: "รายงานเข้าออกห้อง Server",
    icon: DesktopAccess,
    component: ReportAccess,
    layout: "/datacenter"
  },
  {
    path: "/consultants",
    name: "Consultants",
    icon: Person,
    component: Consultants,
    layout: "/datacenter"
  },
  // {
  //   path: "/selecttest",
  //   name: "SelectTest",
  //   icon: Person,
  //   component: SelectTest,
  //   layout: "/datacenter"
  // },
  {
    path: "/logout",
    name: "Logout",
    icon: PersonAdd,
    component: LogoutPage,
    layout: "/auth",
  }

  // {
  //   path: "/dataset",
  //   name: "ชุดข้อมูล",
  //   icon: FolderOpenIcon,
  //   component: Dataset,
  //   layout: "/admin"
  // }
  /*
    ,
  {
    path: "/DashboardVaccine",
    name: "Dashboard Vaccine",
    icon: DeveloperBoardIcon,
    component: DashboardVaccine,
    layout: "/admin"
  }*/
  //   path: "/icons",
  //   name: "Icons",
  //   rtlName: "الرموز",
  //   icon: BubbleChart,
  //   component: Icons,
  //   layout: "/admin"
  // },
  // {
  //   path: "/maps",
  //   name: "Maps",
  //   rtlName: "خرائط",
  //   icon: LocationOn,
  //   component: Maps,
  //   layout: "/admin"
  // },
  // {
  //   path: "/notifications",
  //   name: "Notifications",
  //   rtlName: "إخطارات",
  //   icon: Notifications,
  //   component: NotificationsPage,
  //   layout: "/admin"
  // },
  // {
  //   path: "/rtl-page",
  //   name: "RTL Support",
  //   rtlName: "پشتیبانی از راست به چپ",
  //   icon: Language,
  //   component: RTLPage,
  //   layout: "/rtl"
  // },
  // {
  //   path: "/upgrade-to-pro",
  //   name: "Upgrade To PRO",
  //   rtlName: "التطور للاحترافية",
  //   icon: Unarchive,
  //   component: UpgradeToPro,
  //   layout: "/admin"
  // }
];

export default dashboardRoutes;
